import RedebitListPagingResultModelBase from '../_generated/modelBases/redebit-list-paging-result-model-base';

export default class RedebitListPagingResultModel extends RedebitListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
